module.exports = __webpack_public_path__ + "static/media/Vitaminkliniken uses Curuflow telemedicine platform.faf67e2f.webp";